/**
 * Triumph Wishlist — localStorage-based
 * Stores: [{ id: "shopify_product_id", handle: "product-handle" }]
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'triumph_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function normalizeList(items) {
    var seen = {};
    return (items || []).reduce(function (acc, item) {
      var normalized = null;

      if (item && typeof item === 'object' && item.id != null) {
        normalized = {
          id: String(item.id),
          handle: item.handle ? String(item.handle) : ''
        };
      } else if (item != null && item !== '') {
        normalized = { id: String(item), handle: '' };
      }

      if (!normalized || seen[normalized.id]) return acc;
      seen[normalized.id] = true;
      acc.push(normalized);
      return acc;
    }, []);
  }

  function saveList(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizeList(items)));
  }

  function isInList(productId) {
    return normalizeList(getList()).some(function (i) { return String(i.id) === String(productId); });
  }

  function toggle(productId, productHandle) {
    var items = normalizeList(getList());
    var pid = String(productId);
    var idx = items.findIndex(function (i) { return String(i.id) === pid; });
    if (idx === -1) {
      items.push({ id: pid, handle: productHandle ? String(productHandle) : '' });
    } else {
      items.splice(idx, 1);
    }
    saveList(items);
    return idx === -1; // true = added
  }

  // ── Toast notification ─────────────────────────────────────────────────────

  function showToast(added) {
    var existing = document.getElementById('wishlist-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'wishlist-toast';
    toast.style.cssText = [
      'position:fixed',
      'top:80px',
      'right:20px',
      'z-index:99999',
      'background:#fff',
      'color:#111',
      'font-size:13px',
      'font-family:inherit',
      'letter-spacing:.03em',
      'padding:14px 20px',
      'border-radius:2px',
      'box-shadow:0 4px 20px rgba(0,0,0,.15)',
      'display:flex',
      'align-items:center',
      'gap:10px',
      'opacity:0',
      'transform:translateY(-8px)',
      'transition:opacity .25s ease,transform .25s ease',
      'pointer-events:none'
    ].join(';');

    var msg = added ? 'This item was added to your Wishlist' : 'This item was removed from your Wishlist';
    toast.innerHTML = '<span>' + msg + '</span>'
      + (added ? '<span style="color:#111;font-size:15px;font-weight:600;">&#10003;</span>' : '');

    document.body.appendChild(toast);

    // trigger animation
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.style.opacity = '1';
        toast.style.transform = 'translateY(0)';
      });
    });

    setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(-8px)';
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 300);
    }, 3000);
  }

  // ── Badge ──────────────────────────────────────────────────────────────────

  function updateBadge() {
    var count = normalizeList(getList()).length;
    document.querySelectorAll('.js-wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.dataset.count = count;
      if (count > 0) {
        el.classList.add('icon__badge--show');
      } else {
        el.classList.remove('icon__badge--show');
      }
    });
  }

  // ── Product-tile buttons ───────────────────────────────────────────────────

  function updateButtons() {
    var ids = normalizeList(getList()).map(function (i) { return String(i.id); });
    document.querySelectorAll('.js-toggleWishlist').forEach(function (btn) {
      var active = ids.includes(String(btn.dataset.productId || btn.dataset.ean || ''));
      btn.classList.toggle('js-toggleWishlist--active', active);
      btn.classList.toggle('button--active', active);
      var icon = btn.querySelector('.button__icon, .js-wishlistIcon');
      if (icon) {
        icon.classList.remove('icon-heart', 'icon-heart-o');
        icon.classList.add(active ? 'icon-heart' : 'icon-heart-o');
      }
      var addText = btn.querySelector('.wishlistText--add');
      var removeText = btn.querySelector('.wishlistText--remove');
      if (addText && removeText) {
        addText.style.display = active ? 'none' : '';
        removeText.style.display = active ? '' : 'none';
      }
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function initToggleButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-toggleWishlist');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var added = toggle(btn.dataset.productId, btn.dataset.productHandle || '');
      updateBadge();
      updateButtons();
      showToast(added);
      // Remove focus so :focus CSS doesn't keep the heart appearing filled
      btn.blur();
      // re-render flyout if it's open
      var flyout = document.getElementById('wishlistflyout');
      if (flyout && flyout.classList.contains('flyout--active')) {
        renderFlyout();
      }
    }, true);
  }

  // ── Flyout rendering ───────────────────────────────────────────────────────

  function money(cents) {
    return (cents / 100).toFixed(2);
  }

  function productCardHTML(product) {
    var variant = product.variants[0];
    var imgSrc = product.featured_image
      ? product.featured_image.replace(/(\.[a-z]+)$/, '_280x350$1')
      : '';
    return [
      '<div class="wishlist__item d-flex gap-3 mb-4 pb-3 border-bottom" data-product-id="' + product.id + '">',
      '  <a href="/products/' + product.handle + '" class="flex-shrink-0">',
      '    <img src="' + imgSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '"',
      '         width="80" height="100" loading="lazy"',
      '         style="object-fit:cover;width:80px;height:100px;display:block;">',
      '  </a>',
      '  <div class="flex-grow-1">',
      '    <div class="wishlist__item-name text-uppercase mb-1" style="font-size:11px;font-weight:500;letter-spacing:.05em;">' + product.title + '</div>',
      '    <div class="wishlist__item-price mb-3" style="font-size:12px;">&pound;' + money(variant.price) + '</div>',
      '    <a href="/products/' + product.handle + '" class="button button--secondary" style="font-size:11px;padding:6px 14px;">View Product</a>',
      '  </div>',
      '  <button class="js-wishlist-remove bg-transparent border-0 p-0 align-self-start"',
      '          data-product-id="' + product.id + '" aria-label="Remove from wishlist">',
      '    <i class="icon icon-close icon--xsmall"></i>',
      '  </button>',
      '</div>'
    ].join('\n');
  }

  function renderFlyout() {
    var flyout = document.getElementById('wishlistflyout');
    if (!flyout) return;
    var container = flyout.querySelector('.js-wishlist-items');
    if (!container) return;

    var items = getList();
    if (items.length === 0) {
      container.innerHTML = '<p class="text-center py-5" style="font-size:13px;">Your wishlist is empty.</p>';
      return;
    }

    container.innerHTML = '<div class="text-center py-4"><div class="spinner-border spinner-border-sm" role="status"></div></div>';

    var promises = items.map(function (item) {
      return fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    });

    Promise.all(promises).then(function (products) {
      var html = products.filter(Boolean).map(productCardHTML).join('');
      container.innerHTML = html || '<p class="text-center py-5" style="font-size:13px;">Your wishlist is empty.</p>';
    });
  }

  // ── Flyout open/close ──────────────────────────────────────────────────────

  function openFlyout() {
    var flyout = document.getElementById('wishlistflyout');
    var header = document.querySelector('.js-flexHeader');
    if (!flyout) return;
    // close other active flyouts first
    document.querySelectorAll('.flyout--active').forEach(function (f) {
      f.classList.remove('flyout--active');
    });
    flyout.classList.add('flyout--active');
    if (header) {
      header.classList.add('flexHeader--active');
      header.classList.add('flexHeader--active-flyout');
    }
    // show overlay
    var overlay = document.querySelector('.flyoutWrapper');
    if (overlay) overlay.classList.add('flyoutWrapper--active');
    renderFlyout();
  }

  function initFlyoutTrigger() {
    var wishlistLink = document.querySelector('[data-ta-id="wishlist-icon"]');
    if (!wishlistLink) return;
    wishlistLink.addEventListener('click', function (e) {
      e.preventDefault();
      openFlyout();
    });

    // remove from wishlist inside flyout
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-wishlist-remove');
      if (!btn) return;
      var productId = btn.dataset.productId;
      var items = getList().filter(function (i) { return String(i.id) !== String(productId); });
      saveList(items);
      updateBadge();
      updateButtons();
      renderFlyout();
    });
  }

  // ── Init ───────────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    updateBadge();
    updateButtons();
    initToggleButtons();
    initFlyoutTrigger();
  });

})();
